<om-hero></om-hero>
<ng-container
  *ngIf="this.user.isDirectSignupEligible; then directSignup; else referralBanner"
></ng-container>
<ng-template #directSignup> <om-direct-signup-banner></om-direct-signup-banner> </ng-template>
<ng-template #referralBanner> <om-referral-banner></om-referral-banner> </ng-template>

<section class="flex-grow-1 py-5">
  <div class="container">
    <div @enter class="row mb-lg-5" *ngFor="let cardRow of cardRows">
      <om-card
        *ngFor="let card of cardRow"
        [card]="card"
        [user]="user"
        [class]="'mb-lg-0 mb-3 col-lg-' + 12 / cardRow.length"
      ></om-card>
    </div>
  </div>
</section>
